<div class="footer-wrapper"
  [class.compact]="over1200">
  &copy; {{year}} -
  {{'Галерија српске историје' | translit}}
</div>